
















































































import BillingProduct from '@/datatypes/billing/product';
import BillingProviderPrice from '@/datatypes/billing/price';
import BillingPriceText from '@/components/billing/price-text.vue';
import BillingProductService from '@/services/billing/BillingProductService';
import BillingPriceService from '@/services/billing/BillingPriceService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import Vue from 'vue';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default Vue.extend({
  data: () => ({
    billingProduct: new BillingProduct({}),
    billingPrices: new Array<BillingProviderPrice>(),
    billingProductService: new BillingProductService(),
    billingPriceService: new BillingPriceService(),
    billingPrice: new BillingProviderPrice({}),
    errorMessage: '',
    nextPointer: undefined as undefined | string,
    showInactive: false,
    subscriptionSchemeOption: 'v2',
    isImportingPrice: false,
    showLegacy: false,
  }),

  components: {
    SnackbarMessageHandler,
    BillingPriceText,
  },

  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },

  methods: {
    routeChanged() {
      this.getBillingProduct();
    },

    requestNextPage() {
      this.getBillingPrices();
    },

    getBillingPrices() {
      this.billingProductService.listProviderPrices(
        this.$route.params.id, this.priceOptions,
      ).then(
        (prices) => {
          this.billingPrices = this.billingPrices.concat(
            prices.data.map(
              (data) => new BillingProviderPrice(camelcaseKeysDeep(data)),
            ),
          );

          if (prices.headers.next) {
            this.nextPointer = prices.headers.next;
          } else {
            this.nextPointer = undefined;
          }
        },
      );
    },

    getBillingProduct() {
      const billingProductId = this.$route.params.id;

      this.billingProductService.showProvider(billingProductId).then((response) => {
        this.billingProduct = new BillingProduct(camelcaseKeysDeep(response.data));

        this.getBillingPrices();
      });
    },

    priceMetadataText(price): string {
      const smsAmount = this.toCurrencyShort(price.metadata.smsUnitAmount);

      let texts: string[] = [];
      if (price.payg()) {
        texts.push(`SMS unit cost: ${smsAmount}`);
      } else {
        texts = [
          `quota: ${price.metadata.quota}`,
          `renews each ${price.metadata.quotaRenewal}`,
          `SMS unit cost: ${smsAmount}`,
        ];
      }

      if (texts.length > 0) {
        return `(${texts.join(', ')})`;
      }

      return '';
    },

    toCurrencyShort(value): string {
      if (typeof value !== 'number') {
        return value;
      }

      const dollars = (value / 100);

      const formatter = new Intl.NumberFormat('en-AU', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });

      return `${formatter.format(dollars)}`;
    },

    requestImport(price): void {
      this.billingPrice = price;
      this.isImportingPrice = true;
    },

    importPrice(price): void {
      this.billingPriceService.import(price.externalId).then((response) => {
        this.$router.push(`/billing-prices/${response.data.id}/edit`);
      });
    },
  },
  computed: {
    hasNextPrices(): boolean {
      return (this.nextPointer !== undefined);
    },
    priceOptions(): object {
      return {
        active: !this.showInactive,
        next: this.nextPointer,
        subscriptionScheme: this.subscriptionSchemeOption,
      };
    },
  },
});
